import styled, { css } from 'styled-components';
import { Popover, Form, Spinner as SpinnerBootstrap } from 'reactstrap';
import colors from '../../../../includes/colors';
import { Link } from 'react-router-dom';

export const SignInForm = styled(Form)`
  padding-left: 20%;
  padding-right: 20%;
  padding-top: 0.8rem;
  padding-bottom: 0.8rem;
  position: relative;

  #sfid-error {
    font-family: 'Roboto', sans-serif;
    line-height: 1.2;
    font-size: .75rem;

  }

  .sfid-button-label[for="sfid-username"] {
    padding-top: 0;
  }

  @media (min-width: 768px) {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  label[for='sfid-username'] {
    position: relative;
    white-space: nowrap;
    color: ${colors.strongGray};
    font-weight: 400;
    margin-bottom: 0.25rem;
    font-size: 0.875rem;
    line-height: 1.5;
  }
  .sfid-disabled {
    background-color: #54a7cf !important;
    cursor: wait !important;
  }

  .togglePassword {
    padding: 10px 5px 9px;
    font-size: 0.875rem;
    border: solid 1px #ced4da;
    color: ${colors.paleBlue};
    background-color: ${colors.paleGray};
    cursor: pointer;
    display: inline-block;
    width: 30%;
    &:active {
      box-shadow: inset 0 5px 10px 0 rgba(0, 0, 0, 0.5);
    }

    @media (min-width: 560px) {
      padding-right: 18px;
      padding-left: 18px;
      width: 22%;
    }
  }
`;

export const ErrorBox = styled.div`
  display: none;
`;

export const Label = styled.label`
  color: ${colors.strongGray};
  font-weight: 400;
  display: inline-block;
  margin-bottom: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.5;
`;

export const Button = styled.div`
  button {
    font-size: 0.875rem;
    background: transparent;
    border: none;
    width: 100%;
    height: 100%;
    display: inline-block;
    color: #fff;
  }
`;

export const ButtonShow = styled.button`
  font-size: 0.875rem;
  border: solid 1px #ced4da;
  color: ${colors.paleBlue};
  background-color: ${colors.paleGray};
  cursor: pointer;
  display: inline-block;
`;

export const Spinner = styled(SpinnerBootstrap)`
  color: ${colors.blue};
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -12.5px;
  margin-top: -12.5px;
  width: 25px;
  height: 25px;
`

export const FormHelpText = styled(Link)`
  font-size: 0.875rem;

  &:hover {
    text-decoration: none;
  }

  ${props =>
    props.marginleft &&
    css`
      margin-left: 0.5rem;
    `}

  ${props =>
    props.big &&
    css`
      font-size: 1rem;
      font-weight: 400;
    `}
`;

export const TooltipBox = styled(Popover)`
  .popover {
    box-shadow: 2px 2px 21px -5px rgba(0, 0, 0, 0.2) !important;
    border-radius: 0.3rem !important;
    padding: 0.5rem;
    font-size: 0.875rem;
  }
  .arrow {
    transform: translateX(-30px);
  }
`;

export const FormFooter = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 20%;
  padding-right: 20%;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
  background-color: ${colors.paleGray};
  justify-content: space-between;
  font-size: 1.125rem;
  font-weight: 300;

  @media (min-width: 768px) {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
`;

export const EmbeddedForm = styled.div`
  padding-top: 0;
  margin-bottom: 0;
  min-height: 220px;

  #sfid-password,
  #sfid-username {
    display: block;
    width: 100%;
    height: calc(1.5em + 1rem + 2px);
    padding: 0.5rem 1rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
  #sfid-password {
    width: 70% !important;
    display: inline-block;

    @media (min-width: 560px) {
      width: 78% !important;
    }
  }
  #sfid-submit {
    display: inline-block;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    margin-bottom: 0;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 1px solid transparent;
    padding: 0.5rem 1rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    color: #fff;
    background-color: #007db8;
    border-color: #007db8;
    max-width: 90px;
    &:hover {
      color: #fff;
      background-color: #006392;
      border-color: #005a85;
    }
  }
  label {
    color: ${colors.strongGray};
    font-weight: 400;
    display: block;
    margin-bottom: 0.25rem;
    font-size: 0.875rem;
    line-height: 1.5;
  }
`;

export const TextWrapper = styled.div`
  line-height: 1.24rem; 
`

export const GlobalWrapper = styled.div`
  margin-top: 0.44rem;
  line-height: 1.24rem;
  max-width: 17.875rem;
  font-size: 1rem;
  font-weight: 18.75rem;
  color: #212529;
`

export const GlobalLink = styled.a`
  font-size: 1rem;
  font-weight: 400;

  &:hover {
    text-decoration: none;
  }
`
